import { t } from "../i18n";
import { pimg } from "../art/cast";
import { $ } from "../lib/dom";
import { openDialog } from "./dialog";
import { post } from "./log";
import { dept, L, S } from "./state";

let callReason: unknown = null;
let callDialog = "";

/** The attending's phone rings; answering opens `dlg` and runs its onCall(reason). */
export function incomingCall(reason: unknown, dlg = dept.attendingDialog): void {
  callReason = reason;
  callDialog = dlg;
  $("#callImg").replaceChildren(pimg(dept.attending));
  $("#call").classList.add("show");
  $("#answerBtn").focus();
}

export function initCall(): void {
  $("#answerBtn").onclick = async () => {
    $("#call").classList.remove("show");
    if (!S.live) return;
    const D = L.dialogs[callDialog];
    if (!D) return;
    openDialog(callDialog);
    post(D.ch, "narr", null, t("call.picked"));
    if (!S.llmOff && D.onCall) await D.onCall(callReason);
  };
}
